



























































































































































import Vue from 'vue'
import resetForm from '@morpheus/utils/admin-vue/helpers/resetForm'
import { regexShopCode } from '@morpheus/utils/admin-vue/helpers/regex'
import { ShopCreateData, ShopListingData } from '../types'
import Draggable from 'vuedraggable'
import ListingAddForm from './ListingAddForm.vue'
import ShopEnabledAlert from './ShopEnabledAlert.vue'
import AppDialogConfirm from '@morpheus/utils/admin-vue/components/AppDialogConfirm.vue'

export default Vue.extend({
  name: 'ShopsForm',
  components: {
    Draggable,
    ListingAddForm,
    AppDialogConfirm,
    ShopEnabledAlert
  },
  props: {
    formId: {
      required: true,
      type: String
    },
    editedShop: {
      required: false,
      type: Object,
      default: () => ({})
    },
    btnLabel: {
      required: false,
      type: String,
      default: 'Submit'
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    triggerClear: {
      required: false,
      type: Boolean,
      default: false
    },
    productsList: {
      required: true,
      type: Array
    },
    currenciesListArray: {
      required: true,
      type: Array
    },
    hideListingPopup: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isListingFormShown: false,
      regex: {
        code: regexShopCode
      },
      shop: {
        code: '',
        enabled: false,
        listings: [] as Array<ShopListingData>
      },
      showShopListings: false,
      editedListing: {} as any,
      dialogMessage: '',
      listingIdToRemove: undefined as string|undefined,
      listingFormTitle: ''
    }
  },
  computed: {
    isEditForm (): boolean {
      return this.editedShop.hasOwnProperty('code')
    }
  },
  watch: {
    triggerClear (val: boolean) {
      if (val) {
        this.clear()
      }
    },
    editedShop: {
      deep: true,
      immediate: true,
      handler () {
        for (var prop in this.editedShop) {
          if (this.editedShop.hasOwnProperty(prop)) {
            Vue.set(this.shop, prop, this.editedShop[prop])
          }
        }
      }
    },
    hideListingPopup (val: boolean) {
      if (val) {
        this.isListingFormShown = false
      }
    }
  },
  mounted () {
    this.showShopListings = true
  },
  methods: {
    submit () {
      this.$validator.validateAll()
        .then((result: any) => {
          if (result) {
            const shop: ShopCreateData = {
              code: this.shop.code,
              enabled: this.shop.enabled,
              listings: this.shop.listings
            }
            this.$emit('onSubmit', shop)
          }
        })
    },
    clear () {
      resetForm(this.shop)
      this.shop.listings = []
      this.$validator.reset()
      this.$emit('onClearForm')
    },
    removeListing (index: number) {
      this.listingIdToRemove = this.shop.listings[index]._id
      if (this.listingIdToRemove) {
        this.dialogMessage = `Are you sure you want to delete listing ${index + 1}?`
      } else {
        this.shop.listings.splice(index, 1)
      }
    },
    confirmAction (confirmation: boolean) {
      this.dialogMessage = ''

      if (confirmation) {
        this.$emit('onRemoveListing', this.listingIdToRemove)
      }
    },
    showListingForm (index?: number) {
      this.listingFormTitle = index !== undefined ? 'Edit listing' : ''

      if (index !== undefined) {
        this.editedListing = Object.assign({}, this.editedListing, this.shop.listings[index])
        if (!this.editedListing._id) {
          this.editedListing.index = index
        }
      } else {
        this.editedListing = {}
      }

      this.isListingFormShown = true
    },
    onAddListing (listing: ShopListingData) {
      if (this.editedShop.code) {
        // form edit shop
        this.$emit('addListing', listing)
      } else {
        // form create
        this.shop.listings.push(listing)
        this.isListingFormShown = false
      }
    },
    onUpdateListing (listingId: string, listing: ShopListingData) {
      if (listingId) {
        // form edit
        this.$emit('updateListing', listingId, listing)
      } else {
        // form create
        this.shop.listings[this.editedListing.index] = listing
        this.isListingFormShown = false
        this.editedListing = {}
      }
    },
    hideListingForm () {
      this.isListingFormShown = false
      this.$emit('hideListingForm', false)
    }
  }
})
